class RMForm extends HTMLFormElement {
  constructor() {
    super();
    this.productData = JSON.parse(this.querySelector('.product_json').textContent);
    this.submit = this.querySelector('.pdp_add, [type="submit"]');
    this.notify = this.querySelector('[data-soldout-button]');
    this.notifyPrice = this.notify.querySelector('[data-pdp-price]');
    this.selector = this.querySelector('select[name="id"]');
    this.submitPrice = this.submit.querySelector('[data-pdp-price]');
    this.submitComparePrice = this.submit.querySelector('[data-compare-at-price]');
    this.soldOutModal = document.querySelector('#modal-soldout')
    // Bind methods
    this.onSubmit = this.onSubmit.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    // Observe form submission
    this.addEventListener('submit', this.onSubmit);

    // Variant change event (Shopify themes)
    document.addEventListener('variant:change', this.onVariantChange);

    // Old themes: observe variant select dropdowns
    this.variantSelects = this.querySelectorAll('select[name="id"], [data-product-select]');
    this.variantSelects.forEach(select => {
      select.addEventListener('change', this.onVariantChange);
    });
    this.updatePickersAvailability();
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
    document.removeEventListener('variant:change', this.onVariantChange);

    this.variantSelects?.forEach(select => {
      select.removeEventListener('change', this.onVariantChange);
    });
  }

  getSelectedVariant() {
    const pickers = this.querySelectorAll('variant-picker');
    const selections = [];

    pickers.forEach(picker => {
      const selected = picker.querySelector('.selected');
      if (!selected) return;

      selections.push(
        selected.dataset.value
          .toLowerCase()
          .replace(/\s+/g, '-')
      );
    });

    if (!selections.length) return null;

    const key = selections.join('-');

    return this.productData.variants.find(v =>
      v.options
        .map(o => o.toLowerCase().replace(/\s+/g, '-'))
        .join('-') === key
    );
  }

  updatePickersAvailability() {
    const pickers = this.querySelectorAll('variant-picker');

    pickers.forEach(picker => {
      picker.querySelectorAll('.swatch').forEach(btn => {
        const value = btn.dataset.value;

        const hypothetical = this.productData.variants.some(v => {
          if (!v.available) return false;

          const options = v.options.map(o =>
            o.toLowerCase().replace(/\s+/g, '-')
          );

          return options.includes(
            value.toLowerCase().replace(/\s+/g, '-')
          );
        });

        btn.classList.toggle('is-unavailable', !hypothetical);
        btn.setAttribute('aria-disabled', !hypothetical);
      });
    });
  }


  onSubmit(e) {
    console.log("[RMForm] Submit detected:", this, e);

    // ✔ You can intercept submit here
    e.preventDefault();
    if (this.classList.contains('required-selection')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Add error state for styling / messaging
      this.classList.add('error');

      return false;
    }
    // Your logic...
  }

  onVariantChange(e) {
    const variant = this.getSelectedVariant();

    if (!variant) {
      this.disableSubmit();
      return;
    }

    // Update hidden select
    this.selector.value = variant.id;

    // Update prices
    this.selectedOption = this.selector.querySelector(`option[value="${variant.id}"]`);
    if (this.submitPrice != undefined) {
      this.submitPrice.innerHTML = this.selectedOption.dataset.price;
    }
    if (this.notifyPrice != undefined) {
      this.notifyPrice.innerHTML = this.selectedOption.dataset.price;
    }
    if (this.submitComparePrice != undefined) {
      this.submitComparePrice.innerHTML = this.selectedOption.dataset.compareAtPrice;
    }

    if (this.soldOutModal != undefined && variant.id != undefined) {
      setTimeout(() => {
        this.soldOutModal.querySelector('[name="variant"]').setAttribute('value', variant.id)
      }, 50);
    }

    // Availability control
    if (!variant.available) {
      this.showNotify();
      this.updatePickersAvailability();
      return;
    }

    // Variant is available
    this.showAddToCart();
    this.updatePickersAvailability();
  }

  showNotify() {
    if (this.submit) {
      this.submit.style.display = 'none';
      this.submit.setAttribute('disabled', '');
    }

    if (this.notify) {
      this.notify.style.display = 'block';
    }
  }

  showAddToCart() {
    if (this.submit) {
      this.submit.style.display = '';
      this.submit.removeAttribute('disabled');
    }

    if (this.notify) {
      this.notify.style.display = 'none';
    }
  }


}

// Register custom built-in element
customElements.define('rm-form', RMForm, { extends: 'form' });

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.submit = this.form.querySelector('.pdp_add, [type="submit"]');
    this.options = this.querySelectorAll('.swatch');
    this.label = this.querySelector('.option__label')
    this.type = this.label.dataset.option;
    // this.required = ["size"];
    this.required = "all";
    this.init();
  }
  init () {
    this.options.forEach(btn => btn.addEventListener('click', this.onSelect.bind(this)));
    this.initSelectRequired();
  }

  onSelect(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const option = btn.dataset.option;
    const value = btn.dataset.value;

    // update UI
    this.options.forEach(el =>
      el.classList.remove("selected")
    );
    btn.classList.add("selected");

    // update visible selected value
    this.label.textContent = btn.dataset.title;
    this.updateVariantId();
  }
  updateVariantId() {
    const pickers = document.querySelectorAll("variant-picker");
    const selected = [];

    pickers.forEach(p => {
      selected.push(p.querySelector('.selected').dataset.value.toLowerCase());
    });

    if (!selected.length) return;

    const key = selected.join("-").replace(' ', '-');
    const select = document.querySelector(".variant-id-hidden");
    const match = [...select.options].find(o => o.dataset.values === key);

    if (match) {
      select.value = match.value;
      this.submit.classList.remove('disabled');
      this.submit.removeAttribute('disabled');
      this.form.classList.remove('required-selection');
      this.form.classList.remove('error');
      // select.dispatchEvent(new Event("change"));
      select.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variantId: match.value,
            key
          }
        })
      );
    }
  }

  initSelectRequired() {
    if (this.required.includes(this.type) || this.required == "all") {
      // this.submit.classList.add('disabled');
      // this.submit.setAttribute('disabled','');
      this.form.classList.add('required-selection');
    }
  }
}
customElements.define("variant-picker", VariantPicker);
function initAutoPlayVideo() {
  let videos = document.querySelectorAll('video[autoplay="autoplay"]');
  videos.forEach((video) => {
    if (video.paused || video.ended) {
      video.play();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const selectors = document.querySelectorAll('[data-market-selector]');
  if (!selectors.length) return;

  console.log("Init selectors:", selectors.length);

  selectors.forEach(selector => {
    const toggleBtn = selector.querySelector('[data-dropdown-toggle]');
    const dropdown = selector.querySelector('[data-dropdown-list]');
    const hiddenInput = selector.querySelector('input[name="country_code"]');
    const form = selector.closest('#localization_form');

    if (!toggleBtn || !dropdown || !hiddenInput || !form) return;

    // Toggle dropdown visibility
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent event bubbling
      const isOpen = selector.classList.contains('open');
      
      // Close all others
      document.querySelectorAll('[data-market-selector].open').forEach(openSel => {
        openSel.classList.remove('open');
        openSel.querySelector('[data-dropdown-list]').classList.add('hidden');
      });

      // Toggle this one
      selector.classList.toggle('open', !isOpen);
      dropdown.classList.toggle('hidden', isOpen);
    });

    // Handle option click
    dropdown.querySelectorAll('.market-selector__option').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        if (value) {
          hiddenInput.value = value;
          form.submit();
        }
      });
    });
  });

  // Global click handler: close all if clicked outside
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-market-selector].open').forEach(selector => {
      if (!selector.contains(e.target)) {
        selector.classList.remove('open');
        selector.querySelector('[data-dropdown-list]').classList.add('hidden');
      }
    });
  });
});

